import moment from "moment";
import {isNullOrUndefined} from "util";

export const makeFormData = ({
  name,
  description,
  streamId,
  startTime,
  endTime,
  videoId,
  startImageId,
  endImageId,
  fake,
  source,
  contentCreatorId 
}) => {
  const form = new FormData();
  if (name) form.append('name', name)
  if (description) form.append('description', description)
  if (streamId) form.append('stream_id', streamId)
  if (startTime) form.append('start_time', moment.utc(startTime).format('YYYY-MM-DD HH:mm:ss'))
  if (endTime) form.append('end_time', moment.utc(endTime).format('YYYY-MM-DD HH:mm:ss'))
  if (videoId) form.append('videoId', videoId)
  if (startImageId) form.append('startImageId', startImageId)
  if (endImageId) form.append('endImageId', endImageId)
  if (!isNullOrUndefined(fake)) form.append('fake', fake ? 1 : 0)
  if (source) form.append('source', source)
  if (contentCreatorId) form.append('content_creator_id', contentCreatorId)

  return form
};
